import Vue from 'vue';

// debounce function call; example usages:
// <form @submit.stop.prevent="validateForm" v-debounce="'validateForm'">
// <form @submit.stop.prevent="submit" v-debounce>
Vue.directive('debounce', {
    bind(el, binding, vnode) {
        if (typeof binding.value === 'undefined') {
            binding.value = 'submit';
        }
        vnode.context[binding.value] = _.debounce(vnode.context[binding.value], 2000, {leading: true, trailing: false});
    }
});



// WEBPACK FOOTER //
// ./src/services/Directives.js